module.exports = __webpack_public_path__ + "img/bgr-confetti-2.ea95e3ed.svg";